import { render, staticRenderFns } from "./ReaderTab.vue?vue&type=template&id=680a9062&"
import script from "./ReaderTab.vue?vue&type=script&lang=js&"
export * from "./ReaderTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports